export default class Search {
  constructor() {
    this.results = $('.s7-search-overlay');
    this.searchWrap = $('#search.search-form');
    this.searchField = $('#s7-search');
    this.searchIcon = $('[data-search-icon="search"]');
    this.loadingIcon = $('[data-search-icon="loading"]');
    this.autocompleteTemplate = wp.template('search-autocomplete');
    this.events();
    this.typingCache = [];
    this.minSearchLength = 3;
    this.isOverlayOpen = 0;
    this.previousSearchTerm;
  }

  searchTerm() {
    return this.searchField.val();
  }

  events() {
    this.searchField.on('input', this.typingLogic.bind(this));
    this.searchField.on('focus', () => this.handleFocus());
    $(document).on('click', this.outsideClick.bind(this));
  }

  typingLogic() {
    clearTimeout(this.typingTimer);

    if (this.searchTerm().length < this.minSearchLength) return this.closeResults();
    if (!this.isSpinnerVisible) this.toggleIcon(1);
    if (this.searchTerm().length >= this.minSearchLength &&
      this.searchTerm() != this.previousSearchTerm) this.typingTimer = setTimeout(this.getResults.bind(this), 500);

    this.previousSearchTerm = this.searchTerm();
  }

  getResults() {
    return this.typingCache[this.searchTerm()]
      ? this.openResults(this.typingCache[this.searchTerm()])
      : fetch(s7Data.root_url + '/wp-json/suiteseven/search?s=' + this.searchTerm()).then(response => response.json())
        .then(data => this.openResults(data))
        .catch(() => this.openResults({ searchTerm: this.searchTerm() }));
  }

  toggleIcon(load) {
    const iconOpen = !load ? this.searchIcon : this.loadingIcon;
    const iconClosed = load ? this.searchIcon : this.loadingIcon;
    $(iconOpen).removeClass('d-none');
    $(iconClosed).addClass('d-none');
  }

  outsideClick(e) {
    if (this.isOverlayOpen && !$.contains(this.searchWrap.get(0), e.target)) this.closeResults();
  }

  handleFocus() {
    if (this.searchField.val() == this.previousSearchTerm && this.searchTerm().length >= this.minSearchLength && this.previousSearchTerm) this.openResults();
  }

  openResults(data) {
    if (typeof data === 'object') {
      if (!this.typingCache.hasOwnProperty(this.searchTerm())) this.typingCache[this.searchTerm()] = data;
      this.results.html(this.autocompleteTemplate(data)).fadeIn(200);
    } else {
      this.results.fadeIn(200);
    }

    this.toggleIcon(0);
    this.isOverlayOpen = 1;
  }

  closeResults() {
    this.results.fadeOut(200);
    this.toggleIcon(0);
    this.isOverlayOpen = 0;
  }
}



// WEBPACK FOOTER //
// ./scripts/classes/search.js